import { teamsCalendarsText } from './getSelectedTeamsCalendarsService.locstring.json';
import loc from 'owa-localize';
import { Calendar, CalendarGroupExtended } from 'owa-calendar-cache';
import CalendarColor from 'owa-service/lib/contract/CalendarColor';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import CalendarGroupType from 'owa-service/lib/contract/CalendarGroupType';
import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';
import { TEAMS_CALENDARS_GROUP_ID } from '../constants';
import {
    MailboxInfo,
    MailboxType,
    getUserMailboxInfo,
    getDefaultRoutingKey,
    getRoutingKeyPrefixForSmtpAddress,
} from 'owa-client-ids';
import { LINKEDCALENDAR_ENTRY_TYPE } from 'owa-calendar-properties';
import { TeamsChannel } from 'owa-teams-sds';
import {
    TeamsCalendarsResult,
    GetSelectedTeamsChannelsCalendarsServiceResult,
} from './getSelectedTeamsCalendarsService';

export function processResponse(
    channelsSet: TeamsChannel[]
): GetSelectedTeamsChannelsCalendarsServiceResult | null {
    const groupCalendarsResult: TeamsCalendarsResult[] = [];
    const resultCalendars: Calendar[] = [];

    channelsSet.forEach((selectedChannel: TeamsChannel) => {
        let teamSmtpEmailAddress: string = selectedChannel.teamSmtpAddress.toLowerCase();

        let groupMailboxInfo: MailboxInfo = {
            type: MailboxType.GroupMailbox,
            deprecatedMailboxId: teamSmtpEmailAddress,
            primarySmtpAddress: teamSmtpEmailAddress,
            routingKey: getRoutingKeyPrefixForSmtpAddress() + teamSmtpEmailAddress,
            returnModernConversationItems: false,
            requestOptions: null,
        };

        let calendarEntry: LinkedCalendarEntry = {
            __type: LINKEDCALENDAR_ENTRY_TYPE,
            CalendarColor: CalendarColor.Auto,
            CalendarName: selectedChannel.teamName + '-' + selectedChannel.channelName,
            OwnerEmailAddress: teamSmtpEmailAddress,
            OwnerName: selectedChannel.channelName,
            IsGroupMailboxCalendar: true,
            IsGeneralScheduleCalendar: true,
            ItemId: { Id: selectedChannel.channelId },
            ParentGroupId: TEAMS_CALENDARS_GROUP_ID,
        };

        let calendarFolder: CalendarFolder = {
            DistinguishedFolderId: teamSmtpEmailAddress,
            DisplayName: selectedChannel.channelName,
        };

        groupCalendarsResult.push({
            entry: calendarEntry,
            folder: calendarFolder,
            mailboxInfo: groupMailboxInfo,
        });

        let calendar: Calendar = {
            id: { id: selectedChannel.channelId, mailboxInfo: groupMailboxInfo },
            calculatedFolderId: teamSmtpEmailAddress,
            displayName: selectedChannel.channelName,
            colorScheme: null,
        };

        resultCalendars.push(calendar);
    });

    if (resultCalendars.length > 0) {
        const userMailboxInfo = getUserMailboxInfo();
        const groupsCalendarGroupMailboxInfo: MailboxInfo = {
            type: MailboxType.GroupMailbox,
            deprecatedMailboxId: userMailboxInfo.deprecatedMailboxId, // mailboxId of the account to which these group calendars are associated with
            primarySmtpAddress: userMailboxInfo.primarySmtpAddress, // primary SMTP address of the account to which these group calendars are associated with
            routingKey: getDefaultRoutingKey(),
            returnModernConversationItems: false,
            requestOptions: null,
        };
        const resultGroup: CalendarGroupExtended = {
            id: { id: TEAMS_CALENDARS_GROUP_ID, mailboxInfo: groupsCalendarGroupMailboxInfo },
            GroupId: TEAMS_CALENDARS_GROUP_ID,
            ItemId: { Id: TEAMS_CALENDARS_GROUP_ID },
            GroupName: loc(teamsCalendarsText),
            GroupType: CalendarGroupType.Normal,
        };

        return {
            groupCalendars: groupCalendarsResult,
            calendarGroup: resultGroup,
            calendars: resultCalendars,
        };
    } else {
        return null;
    }
}
